import { css, Global, useTheme } from '@emotion/react';
import { MicrositeTheme } from 'types/MicrositeTheme';

const styles = (theme: MicrositeTheme) => css`
  html,
  body {
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: var(--font-work-sans, 'Work Sans');
    font-size: 16px;
  }

  body {
    overflow-y: scroll;
    /* Override Bootstrap 5's reboot ({ background: var(--bs-body-bg); } → #fff)
       with the active theme bg so the always-on scrollbar gutter (and any
       other body-territory leak past PageContainer) matches PageContainer's
       background-color. Optional chaining keeps SSR safe — theme.customTheme
       is undefined on the server; the fallback inherits Bootstrap's white
       until hydration, after which Emotion re-renders with the real value. */
    background-color: ${theme.customTheme?.colors?.background ?? 'transparent'};
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }

  #__next {
    height: 100%;
  }

  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  span,
  b,
  small {
    font-family: var(--font-work-sans, 'Work Sans'), sans-serif;
  }
`;

export function GlobalStyles() {
  const theme = useTheme() as MicrositeTheme;
  return <Global styles={styles(theme)} />;
}
